import { render, staticRenderFns } from "./groupOrderDuration.vue?vue&type=template&id=0c83e4aa"
import script from "./groupOrderDuration.vue?vue&type=script&lang=js"
export * from "./groupOrderDuration.vue?vue&type=script&lang=js"
import style0 from "./groupOrderDuration.vue?vue&type=style&index=0&id=0c83e4aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports